<template>
  <div>
    <b-table
      responsive
      :items="items"
      :fields="fields"
    >
      <!-- A custom formatted price column -->
      <template #cell(price_amount)="data">
        <display-currency :value="data.value" />
      </template>
      <!-- A custom formatted discount column -->
      <template #cell(discount)="data">
        {{ data.value | numberFormat }} {{ data.value > 100 ? $t('Currency') : '%' }}
      </template>
      <!-- A custom formatted period column -->
      <template #cell(period)="data">
        {{ data.item.display_period }}
      </template>
      <!-- A custom formatted created_at column -->
      <template #cell(created_at)="data">
        <display-date-time :value="data.value" />
      </template>
      <!-- A custom formatted action column -->
      <template #cell(action)="data">
        <b-button
          v-if="$can('update', 'packages')"
          variant="flat-success"
          size="sm"
          class="btn-icon rounded-circle"
          @click="editButtonClicked(data.item)"
        >
          <feather-icon icon="Edit2Icon" />
        </b-button>
      </template>
    </b-table>
    <div
      v-if="!items.length"
      class="d-flex justify-content-center align-items-center"
    >
      <h6 class="font-weight-bolder mb-0">
        {{ $t("There are no packages to display") }}
      </h6>
    </div>
    <packages-edit-modal
      :form="editForm"
      :additional-data="additionalData"
      @onHideModal="resetEditForm"
    />
  </div>
</template>

<script>
import { ListTable } from '../../../../common/mixins/list'
import PackagesEditModal from '../edit/PackagesEditModal'

export default {
  name: 'PackagesList',
  components: { PackagesEditModal },
  mixins: [ListTable],
  data() {
    return {
      routeName: 'packages',
    }
  },
}
</script>

<style scoped>

</style>
